import React, { useRef } from "react";
import PropTypes from "prop-types";
import CopyIcon from "../CopyIcon";
import { CloseIcon } from "../../Svgs/close-icon";
import { socialShareData } from "../../Molecules/SocialShareTemplate/social-share-data";
import { getTextColor } from "../../../utils/utils";
import { STATIC_KEYWORDS } from "../../../../constants";

import "./social-share-popup.m.css";
import { getCategoryAndSubCategory, getTemplateName } from "../../../../ga-utils";

const popupSocialShareItem = (url, icon, text, bgColor, index, name, fullUrl, trackShareClick) => {
  // Create a consistent tracking function for all social icons
  const handleSocialClick = () => {
    trackShareClick(name);
  };

  if (name === "copy") {
    return (
      <div onClick={handleSocialClick}>
        <CopyIcon fullUrl={fullUrl} bgColor={bgColor} icon={icon} />
      </div>
    );
  }

  return (
    <a
      href={url}
      target="_blank"
      rel="nofollow noopener noreferrer"
      styleName="social-wrapper"
      aria-label="social-icon"
      style={{ background: bgColor }}
      onClick={handleSocialClick}
    >
      <div styleName="social-icon-wrapper" data-testid={text} key={`popup-item-${index}`}>
        {icon}
      </div>
    </a>
  );
};

export const SocialSharePopup = ({
  fbUrl = "",
  twitterUrl = "",
  linkedinUrl = "",
  whatsappUrl = "",
  mailtoUrl = "",
  theme,
  closePopup = "",
  iconType,
  fullUrl = "",
  popupText = "",
  onShareClick,
  pageType = "",
  story = {},
  config = {},
  isSummaryCard = false,
  aiHubTemplate = false,
}) => {
  const textColor = getTextColor(theme);
  const iconColor = textColor === "dark" ? "#000000" : "#ffffff";
  const options = { fbUrl, twitterUrl, linkedinUrl, whatsappUrl, mailtoUrl, iconColor, iconType, fullUrl };
  const popupItemsList = socialShareData(options);

  const hasTracked = useRef(false);
  // Track social share clicks with dataLayer
  const shareHandler = (linkText) => {
    if (hasTracked.current) return;
    if (typeof window !== "undefined" && window.dataLayer) {
      const { category, subCategory, contentId } = getCategoryAndSubCategory(window.location, pageType, config, story);

      window.dataLayer.push({
        event: "dl_story_interactions",
        event_action: isSummaryCard ? "short_news_button_click" : "share_click",
        link_text: linkText,
        category: category,
        sub_category: subCategory,
        content_id: contentId,
        template_name: getTemplateName(story?.["story-template"] || pageType),
        platform: window.innerWidth >= 768 ? "desktop" : "mobile",
      });

      hasTracked.current = true;

      // Reset flag after a short delay (after the event sequence completes)
      setTimeout(() => {
        hasTracked.current = false;
      }, 300);
    }
  };
  const trackSocialShare = onShareClick || shareHandler;
  return (
    <div styleName="share-popup-wrapper">
      <div styleName="share-popup">
        <div styleName="top-bar" className="top-bar">
          {aiHubTemplate ? (
            <div styleName="share-text">Share Now</div>
          ) : (
          <div styleName="share-text">{popupText !== "" ? popupText : STATIC_KEYWORDS.SHARE_STORY}</div>
          )}
          <div styleName="close" onClick={closePopup}>
            <CloseIcon color={iconColor} />
          </div>
        </div>
        <div styleName="wrapper" className="wrapper">
          {popupItemsList.map(({ url, icon, text, bgColor, alt, name }, index) =>
            popupSocialShareItem(url, icon, text, bgColor, index, name, fullUrl, trackSocialShare)
          )}
        </div>
      </div>
    </div>
  );
};

SocialSharePopup.propTypes = {
  fbUrl: PropTypes.string,
  twitterUrl: PropTypes.string,
  linkedinUrl: PropTypes.string,
  whatsappUrl: PropTypes.string,
  mailtoUrl: PropTypes.string,
  grey: PropTypes.string,
  popupText: PropTypes.string,
  primaryColor: PropTypes.string,
  closePopup: PropTypes.func,
  theme: PropTypes.string,
  iconType: PropTypes.string,
  fullUrl: PropTypes.string,
  story: PropTypes.object,
  config: PropTypes.object,
  onShareClick: PropTypes.func,
};
